export default __webpack_public_path__ + "static/media/dashboard.279f651d.svg";